/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper';
import { numberFormat } from '../helpers/GlobalHelper';
import { KTSVG } from '../../_metronic/helpers';

interface ProjectOption {
    value: number;
    label: string;
}

interface SrOption {
    value: number;
    label: string;
}

interface Expense {
    projectName: string;
    salesRepresentative: string;
    expenseDate: string;
    expenseCategory: string;
    expenseAmount: number;
    remarks: string;
    taAmount: number;
    daAmount: number;
    otherAmount: number;
    paymentType: string;
    paymentDate: string | null;
    voucherNo: string | null;
}

interface PaymentTypeOption {
    value: string;
    label: string;
}

// Approved lists every approved expense: Paid once its voucher is posted, Due until then.
const paymentTypeOptions: PaymentTypeOption[] = [
    { value: 'approved', label: 'Approved (Paid & Due)' },
    { value: 'paid', label: 'Paid' },
    { value: 'due', label: 'Due' },
];

export function ExpenseReceipt() {
    const [selectProjectOptions, setSelectProjectOptions] = useState<ProjectOption[]>([]);
    const [selectedProject, setSelectedProject] = useState<ProjectOption | null>(null);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [srOptions, setSrOptions] = useState<SrOption[]>([]);
    const [selectedSr, setSelectedSr] = useState<SrOption | null>(null);
    const [paymentType, setPaymentType] = useState<PaymentTypeOption>(paymentTypeOptions[0]);
    const [expenses, setExpenses] = useState<Expense[]>([]);

    const getProjectList = async () => {
        try {
            const url = process.env.REACT_APP_API_URL + 'projects';
            const response = await fetch(url, getRequestOptions());
            const data = await response.json();
            const options: ProjectOption[] = (data?.data || []).map((project: any) => ({
                value: project.id_projects,
                label: project.project_name,
            }));
            setSelectProjectOptions(options);
        } catch (error) {
            console.error('Error fetching project list:', error);
            setSelectProjectOptions([]);
        }
    };

    const getSrList = async () => {
        try {
            const url = process.env.REACT_APP_API_URL + 'get_all_sales_representative';
            const response = await fetch(url, getRequestOptions());
            const data = await response.json();
            const options: SrOption[] = (data || []).map((sr: any) => ({
                value: sr.id,
                label: sr.firstName + ' ' + sr.lastName,
            }));
            setSrOptions(options);
        } catch (error) {
            console.error('Error fetching SR list:', error);
            setSrOptions([]);
        }
    };

    const fetchExpenses = async () => {
        try {
            const url = process.env.REACT_APP_API_URL + 'expenses/filter';
            const body = {
                idProjects: selectedProject?.value || null,
                fromDate: fromDate || null,
                toDate: toDate || null,
                idSr: selectedSr?.value || null,
                paymentType: paymentType.value,
            };
            const response = await fetch(url, postRequestOptions(body));
            const data = await response.json();
            if (data.success) {
                setExpenses(data.data || []);
            } else {
                console.error('Error fetching expenses:', data.message);
                setExpenses([]);
            }
        } catch (error) {
            console.error('Error fetching expenses:', error);
            setExpenses([]);
        }
    };

    useEffect(() => {
        getProjectList();
        getSrList();
    }, []);

    const totalTA = expenses.reduce((sum, expense) => sum + Number(expense.taAmount), 0);
    const totalDA = expenses.reduce((sum, expense) => sum + Number(expense.daAmount), 0);
    const totalOther = expenses.reduce((sum, expense) => sum + Number(expense.otherAmount), 0);
    const totalAmount = expenses.reduce((sum, expense) => sum + Number(expense.expenseAmount), 0);

    const colSpan = (!selectedProject && !selectedSr) ? 5 : (!selectedProject || !selectedSr) ? 4 : 3;

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header'>
                    <div className='card-title'>
                        <h3 className='card-label'>Expenses</h3>
                        <small className='text-muted'>| Filter and view expenses</small>
                    </div>
                </div>
                <div className='card-body'>
                    <div className='row mb-4'>
                        <div className='col-md-3'>
                            <Select
                                options={selectProjectOptions}
                                onChange={setSelectedProject}
                                placeholder='Select Project'
                            />
                        </div>
                        <div className='col-md-2'>
                            <input
                                type='date'
                                className='form-control'
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                placeholder='From Date'
                            />
                        </div>
                        <div className='col-md-2'>
                            <input
                                type='date'
                                className='form-control'
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                                placeholder='To Date'
                            />
                        </div>
                        <div className='col-md-3'>
                            <Select
                                options={srOptions}
                                onChange={setSelectedSr}
                                placeholder='Select SR'
                            />
                        </div>
                        <div className='col-md-2'>
                            <Select
                                options={paymentTypeOptions}
                                value={paymentType}
                                onChange={(option) => option && setPaymentType(option)}
                                placeholder='Payment Type'
                            />
                        </div>
                    </div>
                    <div className='row mb-4'>
                        <div className='col-md-12'>
                            <button className='btn btn-primary' onClick={fetchExpenses}>
                                Filter Expenses
                            </button>
                            <a
                                className="btn btn-secondary ms-2"
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`${process.env.REACT_APP_BACKEND}expenses/download?idProjects=${selectedProject?.value || ''}&fromDate=${fromDate || ''}&toDate=${toDate || ''}&idSr=${selectedSr?.value || ''}&paymentType=${paymentType.value}`}
                            >
                                <KTSVG
                                    path='/media/svg/icons/Files/Downloads-folder.svg'
                                    className='svg-icon-5 svg-icon'
                                />
                                Download PDF
                            </a>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-md-12'>
                            <table className='table table-bordered'>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        {!selectedProject && <th>Project</th>}
                                        {!selectedSr && <th>Sales Representative</th>}
                                        <th>Expense Date</th>
                                        <th>Category</th>
                                        <th>TA Amount</th>
                                        <th>DA Amount</th>
                                        <th>Other Amount</th>
                                        <th className='text-center'>Amount</th>
                                        <th>Payment Type</th>
                                        <th>Payment Date</th>
                                        <th>Voucher No</th>
                                        <th>Remarks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {expenses.map((expense, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {!selectedProject && <td>{expense.projectName}</td>}
                                            {!selectedSr && <td>{expense.salesRepresentative}</td>}
                                            <td>{expense.expenseDate}</td>
                                            <td>{expense.expenseCategory}</td>
                                            <td className='text-end'>{numberFormat(expense.taAmount)}</td>
                                            <td className='text-end'>{numberFormat(expense.daAmount)}</td>
                                            <td className='text-end'>{numberFormat(expense.otherAmount)}</td>
                                            <td className='text-end'>{numberFormat(expense.expenseAmount)}</td>
                                            <td>
                                                <span className={`badge ${expense.paymentType === 'Paid' ? 'badge-light-success' : 'badge-light-warning'}`}>
                                                    {expense.paymentType}
                                                </span>
                                            </td>
                                            <td>{expense.paymentDate}</td>
                                            <td>{expense.voucherNo}</td>
                                            <td>{expense.remarks}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colSpan={colSpan} style={{ textAlign: 'right' }}><strong>Total:</strong></td>
                                        <td className='text-end'>{numberFormat(totalTA)}</td>
                                        <td className='text-end'>{numberFormat(totalDA)}</td>
                                        <td className='text-end'>{numberFormat(totalOther)}</td>
                                        <td className='text-end'>{numberFormat(totalAmount)}</td>
                                        <td colSpan={4}></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default ExpenseReceipt;
